'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    (function (Customer, $) {
        var $dom = {};

        var cacheDom = function cacheDom() {
            $dom.recoverPasswordLink = $('[data-recover-password-trigger]');
            $dom.hideRecoverPasswordLink = $('[data-recover-password-hide]');
            $dom.recoverPasswordForm = $('[data-recover-password]');
            $dom.customerLoginForm = $('[data-customer-login]');

            $dom.addressNew = $('[data-address-new]');
            $dom.addressNewForm = $('[data-address-new-form]');
            $dom.addressNewCancel = $('[data-address-new-cancel]');

            $dom.addressEdit = $('[data-address-edit]');
            $dom.addressEditForm = $('[data-address-edit-form]');
            $dom.addressEditCancel = $('[data-address-edit-cancel]');

            $dom.mobileNavigation = $('[data-account-mobile-navigation]');
            $dom.accountError = $('.accountError');

            $dom.togglePassword = $('.togglePassword');
        };

        var forgotForm = function forgotForm() {
            if (window.location.hash == '#recover') {
                $dom.customerLoginForm.hide(0);
                $dom.recoverPasswordForm.show(0);
            }
        };

        var ToggleNewForm = function ToggleNewForm(state) {
            if (state == 'show') {
                $dom.addressNewForm.addClass('active').slideDown(500);
            } else {
                $dom.addressNewForm.removeClass('active').slideUp(500);
            }
        };

        var ToggleEditForm = function ToggleEditForm(id, state) {
            if (state == 'show') {
                $('[data-address-edit-form][data-address-id="' + id + '"]').addClass('active').slideDown(500);
            } else {
                $('[data-address-edit-form][data-address-id="' + id + '"]').removeClass('active').slideUp(500);
            }
        };

        var showRecoverPasswordForm = function showRecoverPasswordForm() {
            $dom.recoverPasswordForm.show();
            $dom.customerLoginForm.hide();
            $dom.accountError.hide();
            $('html, body').animate({
                scrollTop: $(".accountForgot").offset().top - 250
            }, 10);
        };

        var hideRecoverPasswordForm = function hideRecoverPasswordForm() {
            $dom.recoverPasswordForm.hide();
            $dom.customerLoginForm.show();
            $dom.accountError.hide();
        };

        var bindUIActions = function bindUIActions() {
            $dom.recoverPasswordLink.on('click', function (evt) {
                evt.preventDefault();
                showRecoverPasswordForm();
            });
            $dom.hideRecoverPasswordLink.on('click', function (evt) {
                //history.replaceState(null, null, ' ');
                //evt.preventDefault();
                hideRecoverPasswordForm();
            });

            $dom.addressNew.on('click', function () {
                ToggleNewForm('show');
            });
            $dom.addressNewCancel.on('click', function () {
                ToggleNewForm('hide');
            });

            $dom.addressEdit.on('click', function () {
                var id = $(this).attr('data-address-id');
                ToggleEditForm(id, 'show');
            });
            $dom.addressEditCancel.on('click', function () {
                var id = $(this).attr('data-address-id');
                ToggleEditForm(id, 'hide');
            });

            $dom.mobileNavigation.on('change', function () {
                window.location.href = $(this).val();
            });

            setTimeout(function () {
                //$('#CustomerEmail').val();
                // $('#CustomerPassword').val();
                $('input:-internal-autofill-selected').addClass("focus");
                //$('input:-webkit-autofill').addClass("focus");
                $('input:-internal-autofill-selected').parents('.accountForm__fieldMain').find('label').addClass("focus");
                //$('input:-webkit-autofill').parents('.accountForm__fieldMain').find('label').addClass("focus");
            }, 1000);

            $('.accountForm__fieldMain input').blur(function () {
                if (!$(this).val()) {
                    $(this).removeClass("focus");
                    $(this).parents('.accountForm__fieldMain').find('label').removeClass("focus");
                } else {
                    $(this).addClass("focus");
                    $(this).parents('.accountForm__fieldMain').find('label').addClass("focus");
                }
            });

            $('.accountForm__fieldMain input').focus(function () {
                $(this).addClass("focus");
                $(this).parents('.accountForm__fieldMain').find('label').addClass("focus");
            });

            $('.accountForm__fieldMain input').each(function () {
                if (!$(this).val()) {
                    $(this).removeClass("focus");
                    $(this).parents('.accountForm__fieldMain').find('label').removeClass("focus");
                } else {
                    $(this).addClass("focus");
                    $(this).parents('.accountForm__fieldMain').find('label').addClass("focus");
                }
            });

            $(".accountForm__fields input").on('click', function () {
                $(this).addClass("focus");
                $(this).parents('.accountForm__fieldMain').find('label').addClass("focus");
            });

            if ($(".accountForgot .errors").length > 0) {
                $('#RecoverEmail').parents('.accountForm__fields').addClass('error');
                $('#RecoverEmail').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                $('#RecoverEmail').parents('.accountForm__fieldMain').find('.accountError__message').text('Invalid Email Address.');
                $('#RecoverEmail').parents('.accountForm__fieldMain').find('label').addClass("focus");
                $('#RecoverEmail').parents('.accountForm__fieldMain').find('input').addClass("focus");
            }

            $(".togglePassword").click(function () {
                $(this).toggleClass("is-show");
                var input = $(this).parents('.accountForm__fields').find('.password');

                if (input.attr("type") == "password") {
                    input.attr("type", "text");
                } else {
                    input.attr("type", "password");
                }
            });

            $("#signin-btn").on('click', function () {
                var email = document.getElementById("CustomerEmail");
                var password = document.getElementById("CustomerPassword");
                if (email.value == "") {
                    email.focus();
                    $('#CustomerEmail').parents('.accountForm__fields').addClass('error');
                    $('#CustomerEmail').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                    $('#CustomerEmail').parents('.accountForm__fieldMain').find('.accountError__message').text('Invalid Email Address.');
                    $('#CustomerEmail').parents('.accountForm__fieldMain').find('label').addClass("focus");
                    $('#CustomerEmail').parents('.accountForm__fieldMain').find('input').addClass("focus");
                    return false;
                } else {
                    $('#CustomerEmail').parents('.accountForm__fields').removeClass('error');
                    $('#CustomerEmail').parents('.accountForm__fieldMain').find('.accountError__message').removeClass('is-show');
                }
                if (email.value.indexOf("@", 0) < 0) {
                    email.focus();
                    $('#CustomerEmail').parents('.accountForm__fields').addClass('error');
                    $('#CustomerEmail').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                    $('#CustomerEmail').parents('.accountForm__fieldMain').find('.accountError__message').text('Invalid Email Address.');
                    $('#CustomerEmail').parents('.accountForm__fieldMain').find('label').addClass("focus");
                    $('#CustomerEmail').parents('.accountForm__fieldMain').find('input').addClass("focus");
                    return false;
                } else {
                    $('#CustomerEmail').parents('.accountForm__fields').removeClass('error');
                    $('#CustomerEmail').parents('.accountForm__fieldMain').find('.accountError__message').removeClass('is-show');
                }
                if (email.value.indexOf(".", 0) < 0) {
                    email.focus();
                    $('#CustomerEmail').parents('.accountForm__fields').addClass('error');
                    $('#CustomerEmail').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                    $('#CustomerEmail').parents('.accountForm__fieldMain').find('.accountError__message').text('Invalid Email Address.');
                    $('#CustomerEmail').parents('.accountForm__fieldMain').find('label').addClass("focus");
                    $('#CustomerEmail').parents('.accountForm__fieldMain').find('input').addClass("focus");
                    return false;
                } else {
                    $('#CustomerEmail').parents('.accountForm__fields').removeClass('error');
                    $('#CustomerEmail').parents('.accountForm__fieldMain').find('.accountError__message').removeClass('is-show');
                }
                if (password.value == "") {
                    password.focus();
                    $('#CustomerPassword').parents('.accountForm__fields').addClass('error');
                    $('#CustomerPassword').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                    $('#CustomerPassword').parents('.accountForm__fieldMain').find('.accountError__message').text('Enter a Password.');
                    $('#CustomerPassword').parents('.accountForm__fieldMain').find('label').addClass("focus");
                    $('#CustomerPassword').parents('.accountForm__fieldMain').find('input').addClass("focus");
                    return false;
                } else {
                    $('#CustomerPassword').parents('.accountForm__fields').removeClass('error');
                    $('#CustomerPassword').parents('.accountForm__fieldMain').find('.accountError__message').removeClass('is-show');
                }
                return true;
            });

            $("#forgot-btn").on('click', function () {
                var email = document.getElementById("RecoverEmail");
                if (email.value == "") {
                    email.focus();
                    $('#RecoverEmail').parents('.accountForm__fields').addClass('error');
                    $('#RecoverEmail').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                    $('#RecoverEmail').parents('.accountForm__fieldMain').find('.accountError__message').text('Invalid Email Address.');
                    $('#RecoverEmail').parents('.accountForm__fieldMain').find('label').addClass("focus");
                    $('#RecoverEmail').parents('.accountForm__fieldMain').find('input').addClass("focus");
                    return false;
                } else {
                    $('#RecoverEmail').parents('.accountForm__fields').removeClass('error');
                    $('#RecoverEmail').parents('.accountForm__fieldMain').find('.accountError__message').removeClass('is-show');
                }
                if (email.value.indexOf("@", 0) < 0) {
                    email.focus();
                    $('#RecoverEmail').parents('.accountForm__fields').addClass('error');
                    $('#RecoverEmail').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                    $('#RecoverEmail').parents('.accountForm__fieldMain').find('.accountError__message').text('Invalid Email Address.');
                    $('#RecoverEmail').parents('.accountForm__fieldMain').find('label').addClass("focus");
                    $('#RecoverEmail').parents('.accountForm__fieldMain').find('input').addClass("focus");
                    return false;
                } else {
                    $('#RecoverEmail').parents('.accountForm__fields').removeClass('error');
                    $('#RecoverEmail').parents('.accountForm__fieldMain').find('.accountError__message').removeClass('is-show');
                }
                if (email.value.indexOf(".", 0) < 0) {
                    email.focus();
                    $('#RecoverEmail').parents('.accountForm__fields').addClass('error');
                    $('#RecoverEmail').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                    $('#RecoverEmail').parents('.accountForm__fieldMain').find('.accountError__message').text('Invalid Email Address.');
                    $('#RecoverEmail').parents('.accountForm__fieldMain').find('label').addClass("focus");
                    $('#RecoverEmail').parents('.accountForm__fieldMain').find('input').addClass("focus");
                    return false;
                } else {
                    $('#RecoverEmail').parents('.accountForm__fields').removeClass('error');
                    $('#RecoverEmail').parents('.accountForm__fieldMain').find('.accountError__message').removeClass('is-show');
                }
                return true;
            });

            $("#signup-btn").on('click', function () {
                var name = document.getElementById("FirstName");
                var lastname = document.getElementById("LastName");
                var email = document.getElementById("Email");
                var password = document.getElementById("CreatePassword");

                if (name.value == "") {
                    name.focus();
                    $('#FirstName').parents('.accountForm__fields').addClass('error');
                    $('#FirstName').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                    $('#FirstName').parents('.accountForm__fieldMain').find('.accountError__message').text('Enter your First Name.');
                    $('#FirstName').parents('.accountForm__fieldMain').find('label').addClass("focus");
                    $('#FirstName').parents('.accountForm__fieldMain').find('input').addClass("focus");
                    return false;
                } else {
                    $('#FirstName').parents('.accountForm__fields').removeClass('error');
                    $('#FirstName').parents('.accountForm__fieldMain').find('.accountError__message').removeClass('is-show');
                }
                if (lastname.value == "") {
                    lastname.focus();
                    $('#LastName').parents('.accountForm__fields').addClass('error');
                    $('#LastName').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                    $('#LastName').parents('.accountForm__fieldMain').find('.accountError__message').text('Enter your Last Name.');
                    $('#LastName').parents('.accountForm__fieldMain').find('label').addClass("focus");
                    $('#LastName').parents('.accountForm__fieldMain').find('input').addClass("focus");
                    return false;
                } else {
                    $('#LastName').parents('.accountForm__fields').removeClass('error');
                    $('#LastName').parents('.accountForm__fieldMain').find('.accountError__message').removeClass('is-show');
                }
                if (email.value == "") {
                    email.focus();
                    $('#Email').parents('.accountForm__fields').addClass('error');
                    $('#Email').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                    $('#Email').parents('.accountForm__fieldMain').find('.accountError__message').text('Invalid Email Address.');
                    $('#Email').parents('.accountForm__fieldMain').find('label').addClass("focus");
                    $('#Email').parents('.accountForm__fieldMain').find('input').addClass("focus");
                    return false;
                } else {
                    $('#Email').parents('.accountForm__fields').removeClass('error');
                    $('#Email').parents('.accountForm__fieldMain').find('.accountError__message').removeClass('is-show');
                }
                if (email.value.indexOf("@", 0) < 0) {
                    email.focus();
                    $('#Email').parents('.accountForm__fields').addClass('error');
                    $('#Email').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                    $('#Email').parents('.accountForm__fieldMain').find('.accountError__message').text('Invalid Email Address.');
                    $('#Email').parents('.accountForm__fieldMain').find('label').addClass("focus");
                    $('#Email').parents('.accountForm__fieldMain').find('input').addClass("focus");
                    return false;
                } else {
                    $('#Email').parents('.accountForm__fields').removeClass('error');
                    $('#Email').parents('.accountForm__fieldMain').find('.accountError__message').removeClass('is-show');
                }
                if (email.value.indexOf(".", 0) < 0) {
                    email.focus();
                    $('#Email').parents('.accountForm__fields').addClass('error');
                    $('#Email').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                    $('#Email').parents('.accountForm__fieldMain').find('.accountError__message').text('Invalid Email Address.');
                    $('#Email').parents('.accountForm__fieldMain').find('label').addClass("focus");
                    $('#Email').parents('.accountForm__fieldMain').find('input').addClass("focus");
                    return false;
                } else {
                    $('#Email').parents('.accountForm__fields').removeClass('error');
                    $('#Email').parents('.accountForm__fieldMain').find('.accountError__message').removeClass('is-show');
                }
                if (password.value == "") {
                    password.focus();
                    $('#CreatePassword').parents('.accountForm__fields').addClass('error');
                    $('#CreatePassword').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                    $('#CreatePassword').parents('.accountForm__fieldMain').find('.accountError__message').text('Enter a Password.');
                    $('#CreatePassword').parents('.accountForm__fieldMain').find('label').addClass("focus");
                    $('#CreatePassword').parents('.accountForm__fieldMain').find('input').addClass("focus");
                    return false;
                } else {
                    $('#CreatePassword').parents('.accountForm__fields').removeClass('error');
                    $('#CreatePassword').parents('.accountForm__fieldMain').find('.accountError__message').removeClass('is-show');
                }
                return true;
            });

            $("#reset-btn").on('click', function () {
                var resetPass = document.getElementById("ResetPassword");
                var confirmPass = document.getElementById("PasswordConfirmation");

                if (resetPass.value == "") {
                    resetPass.focus();
                    $('#ResetPassword').parents('.accountForm__fields').addClass('error');
                    $('#ResetPassword').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                    $('#ResetPassword').parents('.accountForm__fieldMain').find('.accountError__message').text('Enter your Password.');
                    $('#ResetPassword').parents('.accountForm__fieldMain').find('label').addClass("focus");
                    $('#ResetPassword').parents('.accountForm__fieldMain').find('input').addClass("focus");
                    return false;
                } else {
                    $('#ResetPassword').parents('.accountForm__fields').removeClass('error');
                    $('#ResetPassword').parents('.accountForm__fieldMain').find('.accountError__message').removeClass('is-show');
                }
                if (confirmPass.value == "") {
                    confirmPass.focus();
                    $('#PasswordConfirmation').parents('.accountForm__fields').addClass('error');
                    $('#PasswordConfirmation').parents('.accountForm__fieldMain').find('.accountError__message').addClass('is-show');
                    $('#PasswordConfirmation').parents('.accountForm__fieldMain').find('.accountError__message').text('Enter your Confirm Password.');
                    $('#PasswordConfirmation').parents('.accountForm__fieldMain').find('label').addClass("focus");
                    $('#PasswordConfirmation').parents('.accountForm__fieldMain').find('input').addClass("focus");
                    return false;
                } else {
                    $('#PasswordConfirmation').parents('.accountForm__fields').removeClass('error');
                    $('#PasswordConfirmation').parents('.accountForm__fieldMain').find('.accountError__message').removeClass('is-show');
                }
                return true;
            });

            $(".zoomCall__close").on('click', function () {
                $('[data-zoom-call]').hide();
                $('[data-book-call]').show();
                return false;
            });

            $(".zoomCallBook__btn").on('click', function () {
                $('[data-zoom-call]').show();
                $('[data-book-call]').hide();
                return false;
            });
        };

        Customer.init = function () {
            cacheDom();
            forgotForm();
            bindUIActions();
        };
    })(window.Customer = window.Customer || {}, _jquery2.default, undefined);
};